import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { OrderService } from "@gloria-public/order/domain/services/order.service";
import { TranslateService } from "@ngx-translate/core";
import { first } from "rxjs";

@Component({
  selector: "app-payment-result",
  templateUrl: "./payment-result.component.html",
  styleUrls: ["./payment-result.component.scss"],
})
export class PaymentResultComponent implements OnInit {
  public status?: string;
  public hasRemainingItems = false;

  constructor(
    private orderService: OrderService,
    private route: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    const sessionId = this.route.snapshot.queryParamMap.get("session_id");

    if (!sessionId) {
      this.router.navigate(["cart/checkout"]);
      return;
    }

    this.orderService
      .getSessionStatus(sessionId)
      .pipe(first())
      .subscribe({
        next: (status) => {
          this.status = status;

          if (status === "open") {
            this.router.navigate(["cart/checkout"]);
            return;
          } else if (status === "complete") {
            this.orderService
              .getCartItems(this.translateService.currentLang)
              .pipe(first())
              .subscribe({
                next: (items) => {
                  this.hasRemainingItems = items.length > 0;
                },
                error: () => {
                  this.snackBar.open(`❗ ${this.translateService.instant("common.error")}`, "OK", { duration: 5000 });
                },
              });
          } else {
            this.router.navigate(["not-found"]);
          }
        },
        error: (error) => {
          if (error.status === 404) {
            this.router.navigate(["not-found"]);
          } else if (error.status === 403) {
            this.router.navigate(["cart"]);
          } else {
            this.snackBar.open(`❗ ${this.translateService.instant("common.error")}`, "OK", {
              duration: 5000,
            });
            this.router.navigate(["error"]);
          }
        },
      });
  }
}
